module.exports = __webpack_public_path__ + "img/2c29c55.png";